import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Stack,
  Switch,
  Text,
  Spinner,
} from "@chakra-ui/react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import React, { useEffect, useMemo, useState } from "react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import ProductTable from "components/Tables/ProductTable";
import { IoIosArrowDown } from "react-icons/io";
import { productsApiAction } from "stores/redux/apiSlices/productApi/productApiSlice";

function ProductList({ handleAddProduct, handleEdit, handleDelete }) {
  const [isActive, setIsActive] = useState(undefined);
  const [isFavourite, setIsFavourite] = useState(undefined);

  const filters = useMemo(() => {
    const base = { role: "DRIVER", limit: 100 };

    if (isActive === true) base.isActive = true;
    else if (isActive === false) base.isActive = false;

    if (isFavourite === true) base.isFavourite = true;

    return base;
  }, [isActive, isFavourite]);

const {
  data,
  isLoading: apiLoading,
  refetch,
} = productsApiAction.getProductsListApi(filters, {
  refetchOnMountOrArgChange: true,
});

useEffect(() => {
  refetch();
}, [refetch]);

const isLoading = apiLoading; // Use directly

const productsListData = data?.data?.products;

  return (
    <Flex direction="column" pt={{ sm: "125px", md: "75px" }}>
      <Flex
        direction={{ sm: "column", md: "row" }}
        justify="space-between"
        align="center"
        w="100%"
        mb="24px"
      >
        <Button
          mt={0}
          bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
          _hover={{
            bg: "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)",
          }}
          _disabled={{
            _hover: {
              bg: "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)",
            },
          }}
          color="#fff"
          minW="125px"
          h="35px"
          fontSize="xs"
          fontWeight="bold"
          mb={{ sm: "12px", md: "0px" }}
          onClick={handleAddProduct}
        >
          Προσθήκη προϊόντος
        </Button>

        <Stack direction="row" spacing="10px">
          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<IoIosArrowDown />}
              color="gray.700"
              w="125px"
              h="35px"
              bg="#fff"
              fontSize="xs"
            >
              ΦΙΛΤΡΑ
            </MenuButton>
            <MenuList zIndex={100}>
              <MenuItem
                closeOnSelect={false}
                onClick={() =>
                  setIsActive((prev) => (prev === true ? undefined : true))
                }
              >
                <Flex justify="space-between" align="center" w="100%">
                  <Text color="gray.500">Ενεργό</Text> 
                  <Switch
                    size="sm"
                    isChecked={isActive === true}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() =>
                      setIsActive((prev) => (prev === true ? undefined : true))
                    }
                  />
                </Flex>
              </MenuItem>
              <MenuItem
                closeOnSelect={false}
                onClick={() =>
                  setIsActive((prev) => (prev === false ? undefined : false))
                }
              >
                <Flex justify="space-between" align="center" w="100%">
                  <Text color="gray.500">Ανενεργό</Text> 
                  <Switch
                    size="sm"
                    isChecked={isActive === false}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() =>
                      setIsActive((prev) =>
                        prev === false ? undefined : false
                      )
                    }
                  />
                </Flex>
              </MenuItem>
              <MenuDivider />
              <MenuItem
                color="red.300"
                onClick={() => {
                  setIsActive(undefined);
                  setIsFavourite(undefined);
                }}
              >
                Εκκαθάριση
              </MenuItem>
            </MenuList>
          </Menu>

          <Button
            variant="no-hover"
            bg="#fff"
            w="125px"
            h="35px"
            color="gray.700"
            fontSize="xs"
            fontWeight="bold"
            onClick={() => {
              if (!productsListData || productsListData.length === 0) {
                console.warn("No data available to export.");
                return;
              }

              const worksheet = XLSX.utils.json_to_sheet(productsListData);
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
              const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
              });

              const blob = new Blob([excelBuffer], {
                type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });

              const currentDate = new Date().toISOString().split("T")[0];
              saveAs(blob, `productsListData_${currentDate}.xlsx`);
            }}
          >
            ΕΞΑΓΩΓΗ
          </Button>
        </Stack>
      </Flex>

      <Card px="0px">
        <CardBody>
          {isLoading ? (
            <Flex
              justify="center"
              align="center"
              direction="column"
              minH="300px"
              w="100%"
            >
              <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
              <Text mt={4} fontSize="md" color="gray.600">
                Loading products...
              </Text>
            </Flex>
          ) : (
            <ProductTable
              tableData={
                Array.isArray(productsListData) ? productsListData : []
              }
              onDelete={handleDelete}
              onEdit={handleEdit}
            />
          )}
        </CardBody>
      </Card>
    </Flex>
  );
}

export default ProductList;
